import type { NextPage } from 'next'
import { projectTypeItems } from '@/modules/project/types'

// 사업분야
export const Component: NextPage = ({ children }) => {
  const selectedItem = projectTypeItems.find(item => item.value === children) || null;
  if (selectedItem) {
    return (<span>{selectedItem.name}</span>)
  } else {
    return (<span data-value={{children}}>invalid</span>);
  }
}

export default Component
